export default {

  data() {

    return {


    }
  },
  methods: {
    ToMemberCenter(){
      let self = this;
      self.$router.push({
        path:'/My/userInfo'
      });
    }

  },
  created() {
  },
  mounted() {
  },
  watch: {}
}



// WEBPACK FOOTER //
// ./src/views/Me/companyFinished/companyFinished.js